import React from "react";
import PropTypes from "prop-types";
import Hero from "src/app/components/Hero/Hero";
import MyAccount from "src/app/components/MyAccount/MyAccount";

const HeroSection = ({ body }) => {
  if (!Object.keys(body).length) {
    return null;
  }

  const heroText = body.elements[0]?.header.text;
  const heroIsCaps = body.elements[0]?.header.isCaps;
  const heroMediumImage = body.elements[0]?.header["image-medium"]?.src;
  const heroLargeImage = body.elements[0]?.header["image-large"]?.src;
  const myAccountTitle = body.elements[0]?.header?.["myaccount-title"];
  const myAccountButton = body.elements[0]?.header?.["myaccount-button"];
  const myAccountSubHeading =
    body.elements[0]?.header?.["myaccount-subHeading"];

  return (
    <>
      <Hero
        text={heroText}
        isCaps={heroIsCaps}
        mediumImage={heroMediumImage}
        largeImage={heroLargeImage}
        type="getInTouch"
      />
      <MyAccount
        title={myAccountTitle}
        description={myAccountSubHeading}
        buttonText={myAccountButton}
      />
    </>
  );
};

HeroSection.propTypes = {
  body: PropTypes.object,
};

export default HeroSection;
